import assignGlobal from 'js/utils/assign_global';
import registerForRails from 'js/utils/registerForRails';
import { trackClick } from 'js/utils/trackClick';
import * as Dismissibles from 'js/utils/dismissibles';
import * as User from 'js/utils/user';
import { Kale } from 'js/core_webpack/metrics/kale';
import { initializeSentry } from 'js/utils/initializeSentry';

initializeSentry();

function setupGlobals() {
  assignGlobal('Aedu', { trackClick, Dismissibles, User });
  assignGlobal('Kale', Kale);
}

import { startRecordingIfSamplingRequest } from 'js/fullstory';
import { clearAnalyticsQueryParams } from 'js/utils/clear_analytics_query_params';
import { trackCWV } from 'js/utils/trackCWV';
import { startActivityTracking } from 'js/core_webpack/metrics/page_activity_tracking';
import { loadRecordHit } from 'js/utils/loadRecordHit';

function setupTracking() {
  loadRecordHit();
  clearAnalyticsQueryParams();
  trackCWV();
  startRecordingIfSamplingRequest();
  startActivityTracking();
}

import AdminBar from 'js/admin_bar/AdminBarActivator';
import FocusedNav from 'js/header/FocusedNav/FocusedNav';
import LoggedOutBucketingBar from 'js/logged_out_bucketing_bar/LoggedOutBucketingBar';

function setupRailsComponents() {
  registerForRails({
    AdminBar,
    FocusedNav,
    LoggedOutBucketingBar,
  });
}

import {
  setUpLoginButtons,
  setUpMobileHamburgerMenu,
  Props as LoginButtonProps,
} from 'js/simple_layout/header/setUpHeader';
import { consoleLog } from 'js/utils/console';

function setupLoggedOutHeader(loginButtonOptions?: LoginButtonProps) {
  try {
    if (loginButtonOptions) {
      setUpLoginButtons(loginButtonOptions);
    }
  } catch {
    consoleLog(
      "Unable to set up login buttons. This probably means we're already logged in",
    );
  }

  setUpMobileHamburgerMenu();
}

export function setUpModernPage(options?: {
  // See js/simple_layout/header/setUpHeader.ts for instructions on how to
  // enable the react modal login buttons.
  loginButtonOptions?: LoginButtonProps;
}) {
  setupGlobals();
  setupTracking();
  setupRailsComponents();
  setupLoggedOutHeader(options?.loginButtonOptions);
}
